import * as t from 'io-ts';

import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

export const RCustomFieldAttribute = t.type({
  id: t.number,
  value: t.string,
});
export interface CustomFieldAttribute extends t.TypeOf<typeof RCustomFieldAttribute> {}
export const RCustomFieldAttributes = t.readonlyArray(RCustomFieldAttribute);

/*
 * IO methods.
 */

export function parseCustomFieldAttribute(src: any) {
  return (
    src && {
      id: src.custom_field_id,
      value: src.value,
    }
  );
}

function parseCustomFieldAttributes(src: any): ReadonlyArray<CustomFieldAttribute> {
  if (!Array.isArray(src)) {
    return [];
  }

  return src.map(parseCustomFieldAttribute);
}

export const ApiCustomFieldAttributes = makeApiType(
  'customFieldAttributes',
  RCustomFieldAttributes,
  parseCustomFieldAttributes,
);
